import { nhost } from 'utility'
import { gql, GraphQLClient } from 'graphql-request'
import { candidateIdVariants } from 'utility/candidateId'
import { CreateWorkRequest } from 'pages/workrequests'
import { getUser } from './query'
import { IUser } from 'interfaces'
import { InsertNationalAverageVariables } from 'type'
import { mutation } from 'gql-query-builder'

export const INSERT_ONE = (entity: string) =>
  gql`mutation insert_${entity}_one($object: ${entity}_insert_input!) { object: insert_${entity}_one(object: $object) { id } }`

export const INSERT_MANY = (entity: string) =>
  gql`mutation insert_${entity}($objects: [${entity}_insert_input!]!) { objects: insert_${entity}(objects: $objects) { affected_rows } }`

export const UPSERT_ONE = (entity: string, key: string, columns: string) =>
  gql`mutation insert_${entity}_one($object: ${entity}_insert_input!) { object: insert_${entity}_one(object: $object, on_conflict: {constraint: ${key}, update_columns: [${columns}]}) { id } }`

export const UPSERT_MANY = (entity: string, key: string, columns: string) =>
  gql`mutation insert_${entity}($objects: [${entity}_insert_input!]!) { objects: insert_${entity}(objects: $objects, on_conflict: {constraint: ${key}, update_columns: [${columns}]}) { affected_rows } }`

export const UPDATE_ONE = (entity: string) =>
  gql`mutation update_${entity}_by_pk($id: uuid!, $object: ${entity}_set_input) { object: update_${entity}_by_pk(pk_columns: {id : $id}, _set: $object) { id } }`

export const UPDATE_ONE_STR_ID = (entity: string) =>
  gql`mutation update_${entity}_by_pk($id: String!, $object: ${entity}_set_input) { object: update_${entity}_by_pk(pk_columns: {id : $id}, _set: $object) { id } }`

export const UPDATE_MANY = (entity: string) =>
  gql`mutation update_${entity}($where: ${entity}_bool_exp!, $object: ${entity}_set_input) { objects: update_${entity}(where: $where, _set: $object) { affected_rows } }`

export const DELETE_ONE = (entity: string) => gql`mutation delete_${entity}_by_pk($id: uuid!) { object: delete_${entity}_by_pk(id : $id) { id } }`
export const DELETE_MANY = (entity: string) =>
  gql`mutation delete_${entity}($where: ${entity}_bool_exp!) { object: delete_${entity}(where : $where) { affected_rows } }`

export const updateQuestionStatus = async (question_id: string, status: string) => {
  let QUERY = gql`mutation updateQuestionStatus {
   update_questions_by_pk(pk_columns: {id: "${question_id}"}, _set: {status: "${status}"}) {
    id
    status
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const updateWorkRequestStatus = async (work_request_id: string, status: string) => {
  let QUERY = gql`mutation updateWorkRequestStatus {
   update_work_requests_by_pk(pk_columns: {id: "${work_request_id}"}, _set: {status: "${status}"}) {
    id
    status
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const updatePaperWorkRequestStatus = async (work_request_id: string, status: string) => {
  let QUERY = gql`mutation updatePaperWorkRequestStatus {
   update_paper_work_requests_by_pk(pk_columns: {id: "${work_request_id}"}, _set: {status: "${status}"}) {
    id
    status
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const updateQuestionReviewer = async (question_id: string, reviewer_id: string) => {
  let QUERY = gql`mutation updateQuestionReviewer {
   update_questions_by_pk(pk_columns: {id: "${question_id}"}, _set: {reviewer_id: "${reviewer_id}"}) {
    id
    reviewer_id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const updateQuestionApprover = async (question_id: string, approver_id: string) => {
  let QUERY = gql`mutation updateQuestionApprover {
   update_questions_by_pk(pk_columns: {id: "${question_id}"}, _set: {approver_id: "${approver_id}"}) {
    id
    approver_id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const updateCompletionStatus = async (work_request_id: string | undefined, value: any) => {
  let QUERY = gql`mutation update {
  update_work_requests(where: {id:{_eq:"${work_request_id}"}},_set:{completion_status:"${value}"}){
    returning{
      id
    }
  }
}
`
  const { data, error } = await nhost.graphql.request(QUERY)
  if (error) {
    return Promise.resolve(error)
  } else {
    return Promise.resolve('OK')
  }
}
export const updateCompletionStatusPwr = async (work_request_id: string | undefined, value: any) => {
  let QUERY = gql`mutation update {
  update_paper_work_requests(where: {id:{_eq:"${work_request_id}"}},_set:{completion_status:"${value}"}){
    returning{
      id
    }
  }
}
`
  const { data, error } = await nhost.graphql.request(QUERY)
  if (error) {
    return Promise.resolve(error)
  } else {
    return Promise.resolve('OK')
  }
}

export const getLastCreatedWorkRequest = async () => {
  let QUERY = `query {
   work_requests(limit: 1, order_by: {created_at: desc}) {
    id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getLastCreatedPaperWorkRequest = async () => {
  let QUERY = `query {
   paper_work_requests(limit: 1, order_by: {created_at: desc}) {
    id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getLastCreatedPaperRequestList = async (num: string | number) => {
  let QUERY = gql`
    query {
      paper_requests(limit: ${num}, order_by: {created_at: desc}) {
        id
        name
        paper_approver_id
        paper_setter_id
      }
    }`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getCreatedPaperRequestListForTestEvent = async (test_event_id: string) => {
  const QUERY = gql`
  query{paper_requests(where:{test_event_id:{_eq:${test_event_id}}}) {
    id
  }
  }`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getLastCreatedPaperTemplate = async () => {
  let QUERY = `query {
   paper_templates(limit: 1, order_by: {created_at: desc}) {
    id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getLastCreatedQuestion = async () => {
  let QUERY = `query {
   questions(limit: 1, order_by: {created_at: desc}) {
    id
    creator_id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const CreateWorkRequestReviewers = async (objects: any) => {
  let QUERY = gql`insert_work_request_reviewers  {
  insert_work_request_reviewers(objects:  ${objects}){
    returning{
      id
    }
  }
}
`
  const { data } = await nhost.graphql.request(QUERY)
  console.log('calling creation part', data)
  return data
}

// Question Notifications - start ******************************************************
export const createNotificationForReview = async (userId: string, reviewerId: string, workRequest: any, questionId: any) => {
  const title = `New Question Assigned For Review `
  const description = `You have recieved a new question (id: ${questionId}) for review in work request: ${workRequest?.name}`
  const source = 'questions'

  let QUERY = gql`mutation createNotificationForReview {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${reviewerId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createNotificationForApproval = async (userId: string, approverId: string, workRequest: any, questionId: any) => {
  const title = `New Question Assinged For Approval `
  const description = `You have recieved a new question (id: ${questionId}) for approval in work request: ${workRequest?.name}`
  const source = 'questions'

  let QUERY = gql`mutation createNotificationForApproval {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${approverId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createNotificationOpenRequireAmending = async (userId: string, creatorId: string, workRequest: any, questionId: any) => {
  const title = `Question Require Amending`
  const description = `Your question (id: ${questionId}) require some amending. Work request: ${workRequest?.name}`
  const source = 'questions'

  let QUERY = gql`mutation createNotificationOpenRequireAmending {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${creatorId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createNotificationForReviewRequireAmending = async (userId: string, reviewerId: string, workRequest: any, questionId: any) => {
  const title = `Reviewed Question Require Amending`
  const description = `Your reviewed question (id: ${questionId}) require some amending. Work request: ${workRequest?.name}`
  const source = 'questions'

  let QUERY = gql`mutation createNotificationForReviewRequireAmending {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${reviewerId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createNotificationRejectedAtRewiew = async (userId: string, creatorId: string, workRequest: any, questionId: any) => {
  const title = `Question Rejected At Review`
  const description = `Your question (id: ${questionId}) has been rejected by reviewer in work request: ${workRequest?.name}`
  const source = 'questions'

  let QUERY = gql`mutation createNotificationRejectedAtRewiew {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${creatorId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createNotificationRejectedAtApproval = async (
  userId: string,
  creatorId: string,
  reviewerId: string,
  workRequest: any,
  questionId: any
) => {
  const title = `Question Rejected At Approval`
  const descriptionOne = `Your question (id: ${questionId}) has been rejected by approval in work request: ${workRequest?.name}`
  const descriptionTwo = `Your reviewed question (id: ${questionId}) has been rejected by approval in work request: ${workRequest?.name}`
  const source = 'questions'

  let FIRSTQUERY = gql`mutation createNotificationRejectedAtApprovalCreator {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${creatorId}", title: "${title}", description: "${descriptionOne}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`

  let SECONDQUERY = gql`mutation createNotificationRejectedAtApprovalCreator {
  insert_notifications_one(object: { sender: "${userId}",recepient: "${reviewerId}", title: "${title}", description: "${descriptionTwo}", source_name: "${source}"}) {
   id
   title
   sender
   recepient
   source_name
   description

 }
}`
  const { data: firstData } = await nhost.graphql.request(FIRSTQUERY)
  const { data: secondData } = await nhost.graphql.request(SECONDQUERY)
  return { firstData, secondData }
}

// Question Notifications - end ******************************************************

// Paper Notifications - start ******************************************************

export const createNotificationPaperForApproval = async (userId: string, paperApproverId: string, paperRequest: any, paperId: any) => {
  const title = `New Paper Assinged For Approval `
  const description = `You have recieved a new paper (id: ${paperId}) for approval in paper request: ${paperRequest?.name}`
  const source = 'papers'

  let QUERY = gql`mutation createNotificationPaperForApproval {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${paperApproverId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createNotificationPaperRequireAmending = async (userId: string, paperSetterId: string, paperRequest: any, paperId: any) => {
  const title = `Submitted Paper Require Amending`
  const description = `Your submitted paper (id: ${paperId}) require some amending. Paper request: ${paperRequest?.name}`
  const source = 'papers'

  let QUERY = gql`mutation createNotificationPaperRequireAmending {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${paperSetterId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createNotificationPaperApproved = async (userId: string, paperSetterId: string, paperRequest: any, paperId: any) => {
  const title = `Submitted Paper is Approved`
  const description = `Your submitted paper (id: ${paperId}) is approved. Paper request: ${paperRequest?.name}`
  const source = 'papers'

  let QUERY = gql`mutation createNotificationPaperRequireAmending {
   insert_notifications_one(object: { sender: "${userId}",recepient: "${paperSetterId}", title: "${title}", description: "${description}", source_name: "${source}"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

// Paper Notifications - end ******************************************************

// Question Logs - start ******************************************************

export const ReferenceLog = async (reviewer: any, workRequest: any, questionId: string) => {
  const description = `${reviewer?.name} has been assinged to review this question in work request id : ${workRequest?.request_id}`
  const type = 'creation'
  const workRequestId = workRequest?.id

  let QUERY = gql`mutation ReferenceLog {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", paper_id: "", type: "${type}", work_request_id: "${workRequestId}"}) {
    id
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogOpen = async (creatorId: string, workRequest: any, questionId: string, paper?: any) => {
  const { user: creator }: any = await getUser(creatorId)
  const creatorName = creator.displayName
  const type = 'creation'
  let QUERY: string = ''
  const paperId = paper?.paperId
  if (workRequest !== undefined && workRequest !== null) {
    const description = `${creatorName} has created this question in work request id : ${workRequest?.request_id}`
    const workRequestId = workRequest?.id

    QUERY = gql`mutation createLogOpen {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
    id
    description
    type
  }
}`
  }
  if (paperId && paperId.length > 0) {
    const description = `${creatorName} has created this question in paper id : ${paper?.paper_id}`
    QUERY = gql`
   mutation createLogOpen {
    insert_question_logs_one(object:{description:"${description}", question_id:"${questionId}", type: "${type}", paper_id:"${paperId}"}){
      id
      description
      type
    }
   }`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogForReview = async (reviewerId: any, workRequest: any, questionId: string, paperId?: string) => {
  const { user: reviewer }: any = await getUser(reviewerId)
  const reviewerName = reviewer.displayName
  const type = 'creation'
  let QUERY: string = ''
  if (workRequest !== undefined && workRequest !== null) {
    const description = `${reviewerName} has been assinged to review this question in work request id : ${workRequest?.request_id}`
    const workRequestId = workRequest?.id

    QUERY = gql`mutation createLogForReview {
     insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
      id
      description
    type
    }
  }`
  }
  if (paperId && paperId.length > 0) {
    const description = `${reviewerName} has been assinged to review this question in paper Id : ${paperId}`
    QUERY = gql`
    mutation createLogForReview {
      insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", paper_id:"${paperId}"})
    }`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogForApproval = async (reviewerId: string, approverId: string, workRequest: any, questionId: string) => {
  console.log('createLogForApproval', reviewerId, approverId)
  const { user: reviewer }: any = await getUser(reviewerId)
  const { user: approver }: any = await getUser(approverId)
  const reviewerName = reviewer.displayName
  const approverName = approver.displayName

  const description = `${reviewerName} have reviewed and passed the question to ${approverName} for approval in work request id : ${workRequest?.request_id}`
  const type = 'creation'
  const workRequestId = workRequest?.id

  let QUERY = gql`mutation createLogForApproval {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogOpenRequireAmending = async (reviewerId: string, creatorId: string, workRequest: any, questionId: string) => {
  const { user: reviewer }: any = await getUser(reviewerId)
  const { user: creator }: any = await getUser(creatorId)
  const reviewerName = reviewer.displayName
  const creatorName = creator.displayName

  const description = `${reviewerName} (Reviewer) returned this question to ${creatorName} (Creator) for amending in work request id: ${workRequest?.request_id}`
  const type = 'creation'
  const workRequestId = workRequest?.id

  let QUERY = gql`mutation createLogcOpenRequireAmending {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogForReviewRequireAmending = async (approverId: string, reviewerId: string, workRequest: any, questionId: string) => {
  const { user: reviewer }: any = await getUser(reviewerId)
  const { user: approver }: any = await getUser(approverId)
  const reviewerName = reviewer.displayName
  const approverName = approver.displayName

  const description = `${approverName} (Approver) returned this question to ${reviewerName} (Reviewer) for amending in work request id : ${workRequest?.request_id}`
  const type = 'creation'
  const workRequestId = workRequest?.id

  let QUERY = gql`mutation createLogForReviewRequireAmending {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogRejectedAtRewiew = async (reviewerId: string, workRequest: any, questionId: string) => {
  const { user: reviewer }: any = await getUser(reviewerId)
  const reviewerName = reviewer.displayName

  const description = `${reviewerName} rejected this question at review stage in work request id : ${workRequest?.request_id}`
  const type = 'creation'
  const workRequestId = workRequest?.id

  let QUERY = gql`mutation createLogRejectedAtRewiew {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogRejectedAtApproval = async (approverId: string, workRequest: any, questionId: string) => {
  const { user: approver }: any = await getUser(approverId)
  const approverName = approver.displayName

  const description = `${approverName} rejected this question at approval stage in work request id : ${workRequest?.request_id}`
  const type = 'creation'
  const workRequestId = workRequest?.id

  let QUERY = gql`mutation createLogRejectedAtApproval {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogPublished = async (approverId: string, workRequest: any, questionId: string, paper?: any) => {
  const { user: approver }: any = await getUser(approverId)
  const approverName = approver.displayName
  let QUERY = ''
  let description = ''

  const type = 'creation'
  const workRequestId = workRequest?.id
  const paperId = paper?.id

  if (workRequestId) {
    description = `${approverName} have approved and set this question to published status in work request id : ${workRequest?.request_id}`
    QUERY = gql`mutation createLogPublished {
    insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}) {
     id
     description
     type
   }
 }`
  }

  if (paperId) {
    description = `${approverName} have approved and set this question to published status in paper id : ${paper?.paper_id}`

    QUERY = gql`mutation createLogPublished {
      insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", paper_id: "${paperId}"}) {
       id
       description
       type
     }
   }`
  }

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogEdited = async (qbInchargeId: string, workRequest: any, questionId: string, paperId?: string) => {
  const { user: qbIncharge }: any = await getUser(qbInchargeId)
  const qbInchargeName = qbIncharge.displayName
  let QUERY = ''
  let description = ''
  const type = 'creation'
  const workRequestId = workRequest?.id
  if (workRequestId) {
    description = `${qbInchargeName} have cloned this question and set this question to edited status in work request id : ${workRequest?.request_id}`
    QUERY = gql`mutation createLogEdited {
      insert_question_logs_one(object:{description:"${description}", question_id: "${questionId}, type:"${type}", work_request_id: "${workRequestId}"})
    }`
  }
  if (paperId) {
    description = `${qbIncharge} have cloned this question and set this question to edited status in paper id: ${paperId}`
    QUERY = gql`mutation createLogEdited {
      insert_question_logs_one(object:{description:"${description}", question_id:"${questionId}, type="${type}", paper_id:"${paperId}"})
    }`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogRePublished = async (qbInchargeId: string, workRequest: any, questionId: string, paper: any) => {
  const { user: qbIncharge }: any = await getUser(qbInchargeId)
  const qbInchargeName = qbIncharge.displayName
  let QUERY = ''
  let description = ''
  const type = 'creation'
  const workRequestId = workRequest?.id
  const paperId = paper?.id
  if (workRequestId) {
    description = `${qbInchargeName} has reviewed this question and re-enabled it in work request id : ${workRequest?.request_id}`
    QUERY = gql`mutation createLogRePublished {
    insert_question_logs_one(object:{description:"${description}", question_id: "${questionId}, type:"${type}", work_request_id: "${workRequestId}"}){
      id
      type
      description
    }
  }`
  }
  if (paperId) {
    description = `${qbIncharge} has reviewed this question and re-enabled it from paper id: ${paper?.paper_id}`
    QUERY = gql`mutation createLogRePublished {
    insert_question_logs_one(object:{description:"${description}", question_id:"${questionId}, type="${type}", paper_id:"${paperId}"}){
      id
      type
      description
    }
  }`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogActivateDeactivate = async (qbInchargeId: string, workRequest: any, questionId: string, paper: any, action: string) => {
  const { user: qbIncharge }: any = await getUser(qbInchargeId)
  const qbInchargeName = qbIncharge.displayName
  let QUERY = ''
  let description = ''
  const type = 'creation'
  const workRequestId = workRequest?.id
  const paperId = paper?.id

  if (workRequestId) {
    description = `${qbInchargeName} has changed the question usage status to ${action} in work request id : ${workRequest?.request_id}`
    QUERY = gql`mutation createLogAcitvateDeactivate {
      insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}", work_request_id: "${workRequestId}"}){
        id
        type
        description
      }
    }`
  }
  if (paperId) {
    description = `${qbInchargeName} has changed the question usage status to ${action} in paper id: ${paper?.paper_id}`
    QUERY = gql`mutation createLogActivateDeactivate {
      insert_question_logs_one(object:{description:"${description}", question_id:"${questionId}", type:"${type}", paper_id: "${paperId}"}){
        id
        type
        description
      }
    }`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const createLogForQBReview = async (paperSetterId: string, workRequest: any, questionId: string, paper?: any) => {
  const { user: paperSetter }: any = await getUser(paperSetterId)
  const paperSetterName = paperSetter.displayName
  let QUERY = ''
  let description = ''
  const type = 'creation'
  const workRequestId = workRequest?.id
  const paperId = paper?.id
  if (workRequestId) {
    description = `${paperSetterName} has changed the question status to "For Review to QB" in work request id : ${workRequest.request_id}`
    QUERY = gql`mutation createLogForQBReview {
      insert_question_logs_one(object:{description:"${description}", question_id:"${questionId}", type:"${type}", work_request_id:"${workRequestId}"}) {
        id
        description
        type
      }
    }`
  }
  if (paperId) {
    description = `${paperSetterName} has changed the question status to "For Review to QB" in paper id : ${paper.paper_id}`
    QUERY = gql`mutation createLogForQBReview {
      insert_question_logs_one(object:{description:"${description}", question_id:"${questionId}", type:"${type}", paper_id:"${paperId}"}) {
        id
        description
        type
      }
    }`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

// Question Logs - end ******************************************************
export const updateEvaluationDetails = async (id: string, total_score: number, answers: any) => {
  let QUERY = gql`mutation updateEvaluationDetails {
   update_evaluation_details_by_pk(pk_columns: {id: "${id}"}, _set: {total_score: "${total_score}",answers:${answers}}) {
    id
    
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
// ----

export const deletePaperTemplateSubSection = async (id: any) => {
  let QUERY = gql`mutation deletePaperTemplateSubSection {
    delete_paper_template_sub_sections(where:{paper_template_id:{_eq:"${id}"}}){
    affected_rows
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const deleteItemById = async (id: string, tableName: string) => {
  const QUERY = gql`
    mutation deleteItemById($id: uuid!) {
      delete_${tableName}_by_pk(id: $id) {
        id
      }
    }
  `

  try {
    const variables = { id }
    const { data, error } = await nhost.graphql.request(QUERY, variables)
    return data
  } catch (err) {
    console.log(err, 'error')
    throw err
  }
}

// ----
export const addNationalAverage = async (mutationData: any) => {
  const QUERY = gql`
    mutation AddNationalAverage($details: national_average_insert_input!) {
      insert_national_average_one(object: $details) {
        id
        section_wise_average
        test_track_id
        created_at
        test_track_name
        total_national_average
        product_id
      }
    }
  `

  try {
    const details = {
      section_wise_average: mutationData?.section_wise_average,
      product_id: mutationData?.product_id,
      test_track_id: mutationData?.test_track_id,
      product_name: mutationData?.product_name,
      test_track_name: mutationData?.test_track_name,
      total_national_average: mutationData?.total_national_average,
      tq: mutationData?.tq,
      type: mutationData?.type,
    }

    const { data, error } = await nhost.graphql.request(QUERY, { details })
    if (error) {
      console.log(error, 'Error')
      return { status: false }
    } else {
      return { status: true }
    }
  } catch (error) {
    console.error('Error:', error)
  }
}
// ---------------------------------------------------------------------------------------------------------------

export const updateNationalAverage = async (national_average_id: string, mutationData: any) => {
  try {
    const QUERY = gql`
      mutation updateNationalAverage($id: uuid!, $section_wise_average: jsonb!, $total_national_average: float8) {
        update_national_average(
          where: { id: { _eq: $id } }
          _set: { section_wise_average: $section_wise_average, total_national_average: $total_national_average, created_at: "now()" }
        ) {
          affected_rows
          returning {
            id
          }
        }
      }
    `

    const variables = {
      id: national_average_id,
      section_wise_average: mutationData?.section_wise_average,
      total_national_average: mutationData?.total_national_average,
    }

    const { data, error } = await nhost.graphql.request(QUERY, variables)
    if (error) {
      console.log(error)
      return { status: false }
    } else {
      return { status: true }
    }
  } catch (err) {
    console.log(err, 'error from updating national average')
  }
}

//-----

export const addCandidateReportResult = async (mutationData: any) => {
  try {
    const QUERY = gql`
      mutation AddCandidateReportResult($details: candidate_report_data_insert_input!) {
        insert_candidate_report_data_one(object: $details) {
          id
        }
      }
    `

    const details = {
      // uploads sometimes carry the login email (TQ106746@centa.org); scorecards are keyed by the bare id
      candidate_id: String(mutationData?.application_id ?? '').replace(/@centa\.org$/i, ''),
      candidate_name: mutationData?.candidate_name,
      section_level_details: mutationData?.section_level_details,
      section_wise_report_theme_details: mutationData?.section_wise_report_theme_details,
      blooms_level_details: mutationData?.blooms_level_details,
      option_flag_details: mutationData?.option_flag_details,
      evaluation_id: mutationData?.evaluation_id,
      national_average_details: mutationData?.national_average_details,
      skt_id: mutationData?.skt_id || null,
      product_id: mutationData?.product_id || null,
      test_track_id: mutationData?.test_track_id || null,
      digital_badge: mutationData?.digital_badge || null,
      test_date: mutationData?.test_date || null,
      paper_id: mutationData?.paper_id || null,
      test_type: mutationData?.test_type || null,
      issue_date: mutationData?.issue_date || null,
      is_eligible_for_result: mutationData?.is_eligible_for_result,
      is_attended: mutationData?.is_attended,
      is_visible: mutationData?.is_visible === true,
      school_id: mutationData?.school_id || null,
    }

    const { data, error } = await nhost.graphql.request(QUERY, { details })

    if (error) {
      console.error(error)
      return { status: false, error }
    } else {
      console.log(data)
      return { status: true, data }
    }
  } catch (err: any) {
    console.error(err)
    return { status: false, error: err?.message }
  }
}

//--
export const createNotificationVerify = async (evaluation: any, user_id: any) => {
  const title = `Evaluation Verified and Forwarded`
  const description = `Evaluation Request  (id: #${evaluation?.evaluation_request?.request_id}-${evaluation?.evaluation_request?.name}) has been verified and forwarded by Evaluation In Charge`
  const source = 'evaluation_requests'

  let QUERY = gql`mutation createNotificationVerify {
   insert_notifications_one(object: {
     sender: "${user_id}",
     recepient: "${evaluation?.evaluation_request?.createdBy?.id}", 
     title: "${title}", 
     description: "${description}", 
     source_name: "${source}",
     redirect_id:"${evaluation?.evaluation_request?.id}",
     redirect_component:"show",
     recepient_user_role:"deliverymanager"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createNotificationVerifyForEvaluators = async (evaluation: any, user_id: any) => {
  const title = `Evaluation Verified and Forwarded`
  const description = `Evaluation Request  (id: #${evaluation?.evaluation_request?.request_id}-${evaluation?.evaluation_request?.name}) has been verified and forwarded by Evaluation In Charge`
  const source = 'evaluation_requests'
  evaluation?.evaluation_request?.evaluator_ids?.forEach(async (elem: any) => {
    let QUERY = gql`mutation createNotificationVerify {
        
   insert_notifications_one(object: { sender: "${user_id}",recepient: "${elem}", title: "${title}", description: "${description}", source_name: "${source}",redirect_id:"${evaluation?.evaluation_request?.id}",redirect_component:"show",recepient_user_role:"evaluators"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
    const { data } = await nhost.graphql.request(QUERY)
    return data
  })
}
export const createNotificationEvaluationRequest = async (evaluation: any, user_id: string) => {
  const title = `Evaluation Request Created`
  const description = `Evaluation Request  (id: #${evaluation?.name}) has been created and assigned to you`
  const source = 'evaluation_requests'
  // evaluation?.evaluation_request?.evaluator_ids?.forEach(async(elem: any) => {
  let QUERY = gql`mutation createNotificationEvaluationRequest {
        
   insert_notifications_one(object: { sender: "${user_id}",recepient: "${evaluation?.evaluation_in_charge}", title: "${title}", description: "${description}", source_name: "${source}",redirect_id:"${evaluation?.id}",redirect_component:"show",recepient_user_role:"evaluationincharge"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
  // })
}

export const createNotificationFinalVerifyDeliveryManager = async (evaluation: any, user_id: any, evaluators: any) => {
  const title = `Evaluation Final Upload Verified`
  const description = `Evaluation Request  (id: #${evaluation?.evaluation_request?.request_id}-${evaluation?.evaluation_request?.name}) has been verified and finalised by Evaluator ${evaluators?.evaluator?.displayName}`
  const source = 'evaluation_requests'

  let QUERY = gql`mutation createNotificationFinalVerify {
   insert_notifications_one(object: {
     sender: "${user_id}",
     recepient: "${evaluation?.evaluation_request?.createdBy?.id}", 
     title: "${title}", 
     description: "${description}", 
     source_name: "${source}",
     redirect_id:"${evaluation?.evaluation_request?.id}",
     redirect_component:"show",
     recepient_user_role:"deliverymanager"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createNotificationFinalVerifyEvaluationIncharge = async (evaluation: any, user_id: any, evaluators: any) => {
  const title = `Evaluation Final Upload Verified`
  const description = `Evaluation Request  (id: #${evaluation?.evaluation_request?.request_id}-${evaluation?.evaluation_request?.name}) has been verified and finalised by Evaluator ${evaluators?.evaluator?.displayName}`
  const source = 'evaluation_requests'

  let QUERY = gql`mutation createNotificationFinalVerifyEvaluationIncharge {
   insert_notifications_one(object: {
     sender: "${user_id}",
     recepient: "${evaluation?.evaluation_request?.evaluation_in_charge}", 
     title: "${title}", 
     description: "${description}", 
     source_name: "${source}",
     redirect_id:"${evaluation?.evaluation_request?.id}",
     redirect_component:"show",
     recepient_user_role:"evaluationincharge"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createNotificationFinalisedEvaluationIncharge = async (evaluation: any, user_id: any) => {
  const title = `Evaluation Request Completed`
  const description = `Evaluation Request  (id: #${evaluation?.name}) completed`
  const source = 'evaluation_requests'
  // evaluation?.evaluation_request?.evaluator_ids?.forEach(async(elem: any) => {
  let QUERY = gql`mutation createNotificationFinalisedEvaluationIncharge {
        
   insert_notifications_one(object: { sender: "${user_id}",recepient: "${evaluation?.evaluation_in_charge}", title: "${title}", description: "${description}", source_name: "${source}",redirect_id:"${evaluation?.id}",redirect_component:"show",recepient_user_role:"evaluationincharge"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createNotificationFinalisedDeliveryInCharge = async (evaluation: any, user_id: any) => {
  const title = `Evaluation Request Completed`
  const description = `Evaluation Request  (id: #${evaluation?.name}) completed`
  const source = 'evaluation_requests'
  // evaluation?.evaluation_request?.evaluator_ids?.forEach(async(elem: any) => {
  let QUERY = gql`mutation createNotificationFinalisedDeliveryInCharge {
        
   insert_notifications_one(object: { sender: "${user_id}",recepient: "${evaluation?.evaluation_request?.createdBy?.id}", title: "${title}", description: "${description}", source_name: "${source}",redirect_id:"${evaluation?.id}",redirect_component:"show",recepient_user_role:"deliverymanager"}) {
    id
    title
    sender
    recepient
    source_name
    description

  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const updateEvaluationRequestStatus = async (evaluation_id: any) => {
  let QUERY = `query {
  evaluations(where:{id:{_eq:"${evaluation_id}"}}){
    id
    name
    created_at
    evaluation_request{
      id
      name
      evaluators{
        id
        evaluator{
          displayName
        }
        status
      }
    }
    
}
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createUserHistory = async (comp_name: string, action_name: string, ref_id: string, user_id: string, user_role: string) => {
  let id
  if (ref_id === '') id = null
  else id = `"${ref_id}"`

  let QUERY = gql`mutation create_history{
    insert_history_logs_one(object:{
      user_id:"${user_id}",
      action_type:"${action_name}",
      action_ref_id:${id},
      action_component:"${comp_name}",
      user_role:"${user_role}"
    }){
      
        id
      
    }
  }
  
  `

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createLogForSecondReviewer = async (reviewerId1: string, reviewerId2: string, questionId: string) => {
  const { user: reviewer1 }: any = await getUser(reviewerId1)
  const { user: reviewer2 }: any = await getUser(reviewerId2)
  const reviewerName1 = reviewer1.displayName
  const reviewerName2 = reviewer2.displayName

  const description = `${reviewerName1} have requested for a second review and passed the question to ${reviewerName2}`
  const type = 'Second Review'

  let QUERY = gql`mutation createLogForApproval {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createLogForSecondApprover = async (approverId1: string, approverId2: string, questionId: string) => {
  const { user: approver1 }: any = await getUser(approverId1)
  const { user: approver2 }: any = await getUser(approverId2)
  const approverName1 = approver1.displayName
  const approverName2 = approver2.displayName

  const description = `${approverName1} have requested for a second approval and passed the question to ${approverName2}`
  const type = 'Second Approval'

  let QUERY = gql`mutation createLogForApproval {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createLogForFirstReviewer = async (reviewerId1: string, reviewerId2: string, questionId: string) => {
  const { user: reviewer1 }: any = await getUser(reviewerId1)
  const { user: reviewer2 }: any = await getUser(reviewerId2)
  const reviewerName1 = reviewer1.displayName
  const reviewerName2 = reviewer2.displayName

  const description = `${reviewerName2} have reviewed  and passed the question to ${reviewerName1}`
  const type = 'Second Review'

  let QUERY = gql`mutation createLogForApproval {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const createLogForFirstApprover = async (approverId1: string, approverId2: string, questionId: string) => {
  const { user: approver1 }: any = await getUser(approverId1)
  const { user: approver2 }: any = await getUser(approverId2)
  const approverName1 = approver1.displayName
  const approverName2 = approver2.displayName

  const description = `${approverName2} have approved and passed the question to ${approverName1}`
  const type = 'Second Approval'

  let QUERY = gql`mutation createLogForApproval {
   insert_question_logs_one(object: {description: "${description}", question_id: "${questionId}", type: "${type}"}) {
    id
    description
    type
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const updateQuestionsAfterUserChange = async (key: string, old_value: string, new_value: string, wr_id: string) => {
  let QUERY = gql`mutation updateQuestionsAfterUserChange {
     update_questions(where:{work_request_id:{_eq:"${wr_id}"},${key}:{_eq:"${old_value}"}},_set:{${key}:"${new_value}"}){
returning{
  id
  
}
    
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const updateVisibiltityStatus = async (
  candidateIds: string[],
  status: boolean,
  tableName: string,
  checkField: string,
  updateField: string
) => {
  const QUERY =
    tableName === 'candidate_report_data'
      ? gql`
    mutation updateVisibilityStatus($candidateIds: [String!]!, $status: Boolean!) {
      update_${tableName}(where: { ${checkField}: { _in: $candidateIds } }, _set: { ${updateField}: $status }) {
        returning {
          id
        }
      }
    }
  `
      : gql`
  mutation updateVisibilityStatus($candidateIds: [uuid!]!, $status: Boolean!) {
    update_${tableName}(where: { ${checkField}: { _in: $candidateIds } }, _set: { ${updateField}: $status }) {
      returning {
        id
      }
    }
  }
`
  const variables = {
    candidateIds,
    status,
  }
  const { data, error } = await nhost.graphql.request(QUERY, variables)
  return data
}

// Scorecard visibility. Hiding also clears score_card_url so a hidden result keeps no shareable link.
// Returns the stored candidate_ids that were updated, so links can be generated for newly visible ones.
export const setCandidateReportVisibility = async (candidateIds: string[], visible: boolean): Promise<string[]> => {
  const VISIBILITY_QUERY = gql`
    mutation setCandidateReportVisibility($candidateIds: [String!]!, $status: Boolean!) {
      update_candidate_report_data(where: { candidate_id: { _in: $candidateIds } }, _set: { is_visible: $status }) {
        returning {
          candidate_id
        }
      }
    }
  `
  const { data, error }: any = await nhost.graphql.request(VISIBILITY_QUERY, { candidateIds, status: visible })
  if (error) {
    throw error
  }

  if (!visible) {
    // Separate request so hiding still works for roles that cannot update score_card_url;
    // the candidate_report_data trigger (docs/migrations) clears the link in that case.
    const CLEAR_LINK_QUERY = gql`
      mutation clearCandidateScoreCardUrl($candidateIds: [String!]!) {
        update_candidate_report_data(where: { candidate_id: { _in: $candidateIds } }, _set: { score_card_url: null }) {
          affected_rows
        }
      }
    `
    const { error: clearError } = await nhost.graphql.request(CLEAR_LINK_QUERY, { candidateIds })
    if (clearError) {
      console.warn('Could not clear score_card_url for hidden scorecards', clearError)
    }
  }

  return (data?.update_candidate_report_data?.returning || []).map((row: { candidate_id: string }) => row.candidate_id)
}

export const updateTablebyId =async (id: string, value: any, tableName: string, checkField: string, updateField: string) => {
  const QUERY = gql`
    mutation updateTableById($id: uuid!, $value: jsonb!) {
      update_${tableName}(where: { ${checkField}: { _eq: $id } }, _set: { ${updateField}: $value }) {
        returning {
          id
        }
      }
    }
  `

  const variables = {
    id,
    value,
  }
  const { data, error } = await nhost.graphql.request(QUERY, variables)
  return data
}

export const updateQuestionInCleanup = async (question_id: string) => {
  let QUERY = gql`mutation updateCleanupQuestion {
    update_cleanup_window_questions(where:{question_id:{_eq:"${question_id}"}}, _set:{in_cleanup:${false}}) {
returning{
  id
paper_id
question_id
}
    }
  }`
  const data = await nhost.graphql.request(QUERY)
  return data
}
export const updateAiConfigDetails = async (name: any, type: string) => {
  try {
    const tableName = type === 'model' ? `ai_models` : `ai_limit`
    const updateToFalse = type === 'model' ? `model_name:{_neq:"${name}"}` : `limit:{_neq:${name}}`
    const updateToTrue = type === 'model' ? `model_name:{_eq:"${name}"}` : `limit:{_eq:${name}}`
    const QUERY = gql`
    mutation updateAiConfig{
    update_to_false:update_${tableName}(
    where:{${updateToFalse}}
    _set:{in_use:false}
    ){
     affected_rows
    }
    update_to_true:update_${tableName}(
    where:{${updateToTrue}}
    _set:{in_use:true}
    ){
    affected_rows
    }
    }
    `
    const { error, data } = await nhost.graphql.request(QUERY)
    if (data) {
      return data
    } else {
      console.log(error, 'error')
      return { errors: true }
    }
  } catch (err) {
    console.log(err)
  }
}

export const updateProjectReportThemeIds = async (projectId: string, newRTId: string | string[], queryFor: 'addItem' | 'removeItem' = 'addItem') => {
  const typeWiseQuery = queryFor === 'removeItem' ? '_set: { report_theme_ids: $newRTId }' : '_append: { report_theme_ids: $newRTId }'

  const QUERY = gql`
    mutation updateProjectReportThemeIds($projectId: uuid!,  $newRTId: jsonb!) {
      update_project_config(where: { id: { _eq: $projectId } }, ${typeWiseQuery}) {
        returning {
          id
          report_theme_ids
        }
      }
    }
  `

  const { data, error } = await nhost.graphql.request(QUERY, {
    projectId,
    newRTId: Array.isArray(newRTId) ? newRTId : [newRTId],
  })

  console.log(error, 'error is this')
  return data
}

export const deleteCandidate = async (candidateEvaluationId: string, applicationId: string) => {
  try {
    const QUERY =
      candidateEvaluationId && applicationId
        ? gql`
            mutation DeleteCandidateDetails($candidateEvaluationId: uuid!, $applicationIds: [String!]!) {
              delete_candidate_report_data(where: { candidate_id: { _in: $applicationIds } }) {
                affected_rows
              }
              delete_evaluation_details(where: { id: { _eq: $candidateEvaluationId } }) {
                affected_rows
              }
            }
          `
        : gql`
            mutation DeleteCandidateDetails($candidateEvaluationId: uuid!) {
              delete_evaluation_details(where: { id: { _eq: $candidateEvaluationId } }) {
                affected_rows
              }
            }
          `
    const { data, error } = await nhost.graphql.request(
      QUERY,
      candidateEvaluationId && applicationId
        ? { candidateEvaluationId, applicationIds: candidateIdVariants(applicationId) }
        : { candidateEvaluationId }
    )
    return data
  } catch (err) {
    console.log(err, 'error')
    return null
  }
}
export const deleteEvaluationDetails = async (evaluationId: string) => {
  try {
    const QUERY = gql`
      mutation DeleteAllCandidateEvaluation($evaluationId: uuid!) {
        delete_candidate_report_data(where: { evaluation_id: { _eq: $evaluationId } }) {
          affected_rows
        }
        delete_evaluation_details(where: { evaluation_id: { _eq: $evaluationId } }) {
          affected_rows
        }
        delete_evaluations(where: { id: { _eq: $evaluationId } }) {
          affected_rows
        }
      }
    `
    const { data, error } = await nhost.graphql.request(QUERY, { evaluationId })
    return data
  } catch (err) {
    console.log(err, 'error')
    return null
  }
}

export const addRowsToTable = async (tableName: string, rowData: any[]) => {
  try {
    const QUERY = gql`
      mutation InsertRows($objects: [${tableName}_insert_input!]!) {
        insert_${tableName}(objects: $objects) {
          returning {
            id
          }
        }
      }
    `
    const { data, error } = await nhost.graphql.request(QUERY, { objects: rowData })
    console.log(error, 'error')
    if (!error) {
      return data
    }
    return false
  } catch (err) {
    console.log(err, 'err')
    return null
  }
}
